import { createElementFromHTML, smoothScrollTo } from '../../js/helper';
import { AjaxLoader } from '../../js/ajax-loader';
import { sendTracking, getTrackingData, bindTrackingClick } from '../../js/tracking';
import { DetailHandler } from '../../components/detail-handler/detail-handler';
import 'formdata-polyfill';

class Filter {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-productsupport-filter',
            fieldAttr: 'data-input',
            categoryAttr: 'category',
            filterAttr: 'filter',
            resultAttr: 'result',
            resultsAttr: 'results',
            resetAttr: 'reset',
            detailLinkAttr: 'detail',
            closeDetailAttr: 'data-overlay',
            loader: null,
            onSubmitted: null,
            onShowDetails: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$formHandler = element;
        this.$header = document.querySelector('[data-header="root"]');
        this.reset = false;
        this.initDetailHandler = false;
        this.thirdFilterShow = false;
        this.pager = false;
        this.$resultsContainer = document.querySelector('[' + this.settings.initAttr + '="' + this.settings.resultsAttr + '"]');

        if (this.$formHandler.querySelector('form') === null) {
            console.error('no form found');
            return;
        }

        if (this.settings.loader !== null) {
            this.$loader = createElementFromHTML(this.settings.loader);
        }
    }

    initialize () {
        this.initFormFields();
        this.initDetailLinks(this.$formHandler);
        this.setEvents();
        this.initResultsContainer();

        // needed for API
        this.showList = this.showProducts;
        this.hideList = this.hideProducts;
        this.listIsVisible = false;
    }

    setEvents () {
        this.$formHandler.addEventListener('submit', (e) => {
            if (e.target.tagName.toLowerCase() === 'form') {
                this.submitForm(e.target);
            }
            e.preventDefault();
        });

        this.toggleProducts();
    }

    initFilter ($fields, onChange) {
        import('../../components/form/form-input').then(({ FormInput }) => {
            for (let i = 0; i < $fields.length; i++) {
                const $field = $fields[i];
                const formAPI = new FormInput($field);
                $field.API = formAPI;

                const $select = $field.querySelector('select');
                const apiCheckInterval = window.setInterval(() => {
                    if (typeof $select.API !== 'undefined') {
                        clearInterval(apiCheckInterval);

                        const selectBox = $select.API;
                        selectBox.on('selectr.change', (option) => {
                            if (typeof onChange === 'function') {
                                onChange();
                            }

                            // tracking code
                            if ($field.getAttribute('data-tracking-label') && option != null) {
                                const trackingData = {
                                    category: 'product support filter',
                                    action: 'select',
                                    label: $field.getAttribute('data-tracking-label') + ' - ' + option.getAttribute('data-tracking-value')
                                };

                                if (option.getAttribute('data-tracking-value') !== null) {
                                    sendTracking(trackingData);
                                }
                            }

                            if (option !== null) {
                                const $resultsPreviewContainer = document.querySelector('.product-support-form-results-container');
                                $resultsPreviewContainer.classList.add('is--sticky');
                            }
                        });

                        const $resetButton = $field.querySelector('[' + this.settings.initAttr + '="' + this.settings.resetAttr + '"]');
                        if ($resetButton !== null) {
                            $resetButton.addEventListener('click', (e) => {
                                selectBox.setValue('');
                                const $resultsPreviewContainer = document.querySelector('.product-support-form-results-container');
                                $resultsPreviewContainer.classList.remove('is--visible');
                            });
                        }

                        this.setBodyClickEvent();
                    }
                }, 100);
            }
        });
    }

    initFormFields () {
        const $form = this.$formHandler.querySelector('form');
        const $$fields = this.$formHandler.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.filterAttr + '"]');
        const $$categories = this.$formHandler.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.categoryAttr + '"]');
        const $$resetButtons = document.querySelectorAll('.product-support-form-filter__refresh');
        const $backButton = document.querySelector('.product-support-overview-back');
        this.filter = false;

        if ($$fields.length > 0) {
            this.initFilter($$fields, () => {
                if ($form !== null && this.reset === false) {
                    this.filter = true;
                    this.submitForm($form);
                }
            });
        }

        if ($$categories.length > 0) {
            this.initFilter($$categories, () => {
                if ($form !== null && this.reset === false) {
                    this.filter = true;

                    this.resetFields($form, $$fields);
                }
            });
        }

        if ($$resetButtons.length > 0) {
            for (let i = 0; i < $$resetButtons.length; i++) {
                const $resetButton = $$resetButtons[i];

                $resetButton.addEventListener('click', (e) => {
                    if ($resetButton.getAttribute('data-filter-refresh') === 'hide-products') {
                        this.hideProducts('.product-support-tabs');
                    } else {
                        $resetButton.classList.add('is--clicked');
                    }
                    this.resetFields($form, $$categories);
                    setTimeout(() => {
                        const $resultsPreviewContainer = document.querySelector('.product-support-form-results-container');
                        $resultsPreviewContainer.classList.remove('is--visible');
                    }, 1000);
                });
            }
        }

        if ($backButton) {
            $backButton.addEventListener('click', () => {
                this.resetFields($form, $$categories);
            });
        }
    }

    initResultsContainer () {
        this.$resultsContainer.addEventListener('click', (e) => {
            const $handle = e.target;

            if ($handle.getAttribute(this.settings.initAttr) === this.settings.detailLinkAttr) {
                this.detailHandler.showDetail($handle);
                e.preventDefault();
            }
        });
    }

    initDetailLinks ($result) {
        $result.addEventListener('click', (e) => {
            this.$handle = e.target;
            let $selectContainer = null;
            if (this.$handle.classList.contains('selectr-container')) {
                $selectContainer = this.$handle;
            } else {
                $selectContainer = this.$handle.closest('.selectr-container');
            }

            const $productSupportFormFilter = $result.querySelector('.product-support-form__filter');
            if ($selectContainer != null) {
                const $closestGroupContainer = $selectContainer.closest('[role="group"]');
                const $$allGroupContainer = $productSupportFormFilter.querySelectorAll('[role="group"]');

                for (let i = 0; i < $$allGroupContainer.length; i++) {
                    if ($$allGroupContainer[i] !== $closestGroupContainer) {
                        $$allGroupContainer[i].classList.add('has--lower-z-index');
                        $$allGroupContainer[i].classList.remove('has--higher-z-index');
                    }
                }
                $closestGroupContainer.classList.add('has--higher-z-index');
                $closestGroupContainer.classList.remove('has--lower-z-index');
            } else {
                const $$allGroupContainer = $productSupportFormFilter.querySelectorAll('[role="group"]');
                for (let i = 0; i < $$allGroupContainer.length; i++) {
                    $$allGroupContainer[i].classList.remove('has--lower-z-index');
                    $$allGroupContainer[i].classList.remove('has--higher-z-index');
                }
            }
        });
    }

    resetFields ($form, $fields) {
        this.reset = true;
        if ($fields.length > 0) {
            for (let i = 0; i < $fields.length; i++) {
                const $select = $fields[i].querySelector('select');

                const apiCheckInterval = window.setInterval(() => {
                    if (typeof $select.API !== 'undefined') {
                        clearInterval(apiCheckInterval);
                        const selectBox = $select.API;
                        if (selectBox.getValue()) {
                            selectBox.setValue('');
                        }

                        if (i === $fields.length - 1) {
                            this.submitForm($form, true);
                            this.reset = false;
                        }
                    }
                }, 100);
            }
        } else {
            this.submitForm($form, true);
            this.reset = false;
        }
    }

    submitForm ($form, reset = false) {
        if ($form === null) {
            return;
        }

        const $button = $form.querySelector('[type="submit"]');
        if ($button) {
            $button.setAttribute('disabled', true);
            $button.appendChild(this.$loader);
        } else {
            $form.appendChild(this.$loader);
        }
        const $tabBarContent = document.querySelector('.product-support-tabs__tab-bar-content');
        $tabBarContent.style.height = 'auto';

        let formAction = $form.getAttribute('action');
        const formMethod = $form.getAttribute('method');
        const formData = new FormData($form);

        if (formMethod.toLowerCase() === 'get') {
            let queryString = '?';

            for (const entry of formData.entries()) {
                if (entry[1] !== '') {
                    queryString += encodeURIComponent(entry[0]) + '=' + encodeURIComponent(entry[1]) + '&';
                }
            }

            queryString = queryString.slice(0, -1);
            formAction = formAction + queryString;
        }

        this.formResult = new AjaxLoader(formAction, {
            requestMethod: formMethod,
            requestData: formData,
            cache: false,
            onSuccess: (resultText) => {
                const json = JSON.parse(resultText);
                const resultFilter = json.filter;
                const resultResults = json.result;
                const resultPreview = json.result_preview;
                const $productOverviewTeaser = document.querySelector('.product-support-overview-teaser');

                if (resultFilter) {
                    this.$formHandler.innerHTML = '';
                    this.$formHandler.innerHTML = resultFilter;
                }

                if (resultResults) {
                    this.pager = false;
                    const resultsContainer = document.querySelector('.product-support-form-results-container');
                    const resultResultsContainer = document.querySelector('[data-productsupport-filter="results"]');

                    resultResultsContainer.innerHTML = resultResults;
                    if ($productOverviewTeaser.classList.contains('is--hidden')) {
                        resultsContainer.classList.add('is--visible');
                    } else {
                        resultsContainer.classList.remove('is--visible');
                    }

                    bindTrackingClick(resultResultsContainer);
                }

                if (resultPreview) {
                    const resultPreviewContainer = document.querySelector('[data-productsupport-filter="preview"]');
                    resultPreviewContainer.innerHTML = resultPreview;
                }

                let positionTop = this.$formHandler.offsetTop;

                const $errorMessage = this.$formHandler.querySelector('.form__errors');
                if ($errorMessage) {
                    positionTop = $errorMessage.offsetTop;
                }

                const $formResult = this.$formHandler.querySelector('[' + this.settings.initAttr + '="' + this.settings.resultAttr + '"]');
                if ($formResult) {
                    positionTop = $formResult.offsetTop;
                }

                const $tracking = this.$formHandler.querySelector('[data-tracking]');
                if ($tracking) {
                    const trackingData = getTrackingData($tracking);
                    sendTracking(trackingData);
                }

                let scrollToElement = null;
                let stopScrolling = false;
                const $$filterItems = document.querySelectorAll('.product-support-form__filter-item');

                if ($$filterItems.length === 1) {
                    const $filterItemFirst = document.querySelector('.product-support-form__filter-item-first');
                    scrollToElement = $filterItemFirst;
                } else if ($$filterItems.length === 2) {
                    const $filterItemSecond = document.querySelector('.product-support-form__filter-item-second');
                    scrollToElement = $filterItemSecond;
                } else if ($$filterItems.length === 3) {
                    const $filterItemThird = document.querySelector('.product-support-form__filter-item-third');
                    scrollToElement = $filterItemThird;
                    if (!this.thirdFilterShow) {
                        this.thirdFilterShow = true;
                    } else {
                        const windowWidth = window.innerWidth;
                        if (windowWidth < 1024) {
                            stopScrolling = true;
                        }
                    }
                }

                const $refreshButton = document.querySelector('.product-support-form-results-prev .product-support-form-filter__refresh');
                if ($refreshButton) {
                    if ($refreshButton.classList.contains('is--clicked')) {
                        const $productSupportTabs = document.querySelector('.product-support-tabs');
                        scrollToElement = $productSupportTabs;
                        setTimeout(() => {
                            $refreshButton.classList.remove('is--clicked');
                        }, 2000);
                    }
                }

                if (scrollToElement) {
                    positionTop = scrollToElement.getBoundingClientRect().top + window.scrollY;

                    if (this.$header) {
                        positionTop = positionTop - this.$header.offsetHeight;
                    }
                }

                if ($productOverviewTeaser.classList.contains('is--hidden') && !stopScrolling) {
                    smoothScrollTo(0, positionTop, 500);
                }

                this.initFormFields();
                if (reset === false) {
                    this.toggleProducts();
                }

                if (typeof this.settings.onSubmitted === 'function') {
                    this.settings.onSubmitted(this.$formHandler);
                }

                setTimeout(() => {
                    this.setTabBarContentHeight();
                }, 800);
            }
        });
    }

    toggleProducts () {
        const $$toggleProductButtons = document.querySelectorAll('.product-support-form__toggle-results');

        if ($$toggleProductButtons.length > 0) {
            for (let i = 0; i < $$toggleProductButtons.length; i++) {
                const $toggleProductButton = $$toggleProductButtons[i];

                if ($toggleProductButton.getAttribute('initialized') === null) {
                    $toggleProductButton.setAttribute('initialized', true);
                    $toggleProductButton.addEventListener('click', () => {
                        const $results = document.querySelector('.product-support-form-results');
                        if ($results.classList.contains('is--visible')) {
                            this.hideProducts(null);
                        } else {
                            this.showProducts();
                        }
                    });
                }
            }
        }

        const $$filterBarItems = document.querySelectorAll('.product-support-form__results-filter-bar-list-item');
        if ($$filterBarItems.length > 0) {
            for (let i = 0; i < $$filterBarItems.length; i++) {
                const $filterBarItem = $$filterBarItems[i];

                if ($filterBarItem.getAttribute('initialized') === null) {
                    $filterBarItem.setAttribute('initialized', true);
                    $filterBarItem.addEventListener('click', () => {
                        const filter = $filterBarItem.getAttribute('data-product-filter-item');

                        if (filter === '1') {
                            this.hideProducts('.product-support-form__filter-item-first');
                        } else if (filter === '2') {
                            this.hideProducts('.product-support-form__filter-item-second');
                        } else if (filter === '3') {
                            this.hideProducts('.product-support-form__filter-item-third');
                        }
                    });
                }
            }
        }
    }

    showProducts () {
        this.listIsVisible = true;
        const $productSupportStage = document.querySelector('.stage');
        const productSupportStageTop = $productSupportStage.offsetHeight;
        const productSupportStageMargin = parseInt(window.getComputedStyle($productSupportStage).marginBottom.replace('px', ''));
        const windowWidth = window.innerWidth;
        let scrollPosition = productSupportStageTop + productSupportStageMargin;
        if (windowWidth < 1024) {
            scrollPosition = scrollPosition + 80;
        }

        if (this.initDetailHandler === false) {
            this.initDetailHandler = true;
            this.detailHandler = new DetailHandler({
                initContent: this.settings.onShowDetails,
                $loader: this.settings.loader
            });
        }

        const $results = document.querySelector('.product-support-form-results');
        const $topText = document.querySelector('.products-support-text');
        const $preview = document.querySelector('.product-support-form-results-prev');
        const $previewContainer = document.querySelector('.product-support-form-results-container');
        const $tabs = document.querySelector('.product-support-tabs');
        smoothScrollTo(0, scrollPosition, 500);
        setTimeout(() => {
            $results.classList.add('is--visible');
            $topText.classList.add('is--hidden');
            $tabs.classList.add('is--hidden');
            $preview.classList.add('is--hidden');
            $previewContainer.classList.remove('is--sticky');
        }, 1000);

        if (this.pager === false) {
            const $pagerForm = $results.querySelector('[data-product-support="pager"]');
            this.handlePager($pagerForm);
        }
    }

    handlePager ($form) {
        const $pager = $form.querySelector('[data-pager="root"]');
        if ($pager) {
            import('./../../components/pager/pager').then(({ Pager }) => {
                this.pager = true;
                const pagerAPI = new Pager($pager, {
                    onPageUpdate: (page) => {
                        this.getResultsByPage($form, page);
                    }
                });

                $pager.API = pagerAPI;
            });
        }
    }

    getResultsByPage ($form, page) {
        const formAction = $form.getAttribute('action') + '&page=' + page;
        const formMethod = $form.getAttribute('method');
        const formData = new FormData($form);

        const formPageResult = new AjaxLoader(formAction, { // eslint-disable-line
            requestMethod: formMethod,
            requestData: formData,
            cache: false,
            onSuccess: (resultText) => {
                const json = JSON.parse(resultText);
                const $ghostElement = document.createElement('div');
                $ghostElement.innerHTML = json.result;
                const $resultForm = $ghostElement.querySelector('[data-product-support="pager"]');
                $form.innerHTML = $resultForm.innerHTML;
                this.handlePager($form);

                let positionTop = this.$resultsContainer.getBoundingClientRect().top + window.scrollY;
                if (this.$header) {
                    positionTop = positionTop - this.$header.offsetHeight;
                }

                smoothScrollTo(0, positionTop, 500);
            }
        });
    }

    hideProducts (scrollItem) {
        this.listIsVisible = false;
        const $results = document.querySelector('.product-support-form-results');
        const $topText = document.querySelector('.products-support-text');
        const $preview = document.querySelector('.product-support-form-results-prev');
        const $tabs = document.querySelector('.product-support-tabs');
        const $previewContainer = document.querySelector('.product-support-form-results-container');
        const scrollPosition = $tabs.getBoundingClientRect().top + window.scrollY;

        if (scrollItem == null) {
            smoothScrollTo(0, scrollPosition, 500);
        }
        setTimeout(() => {
            $results.classList.remove('is--visible');
            $topText.classList.remove('is--hidden');
            $tabs.classList.remove('is--hidden');
            $preview.classList.remove('is--hidden');
            $previewContainer.classList.add('is--sticky');

            if (scrollItem !== null) {
                const $scrollItem = document.querySelector(scrollItem);
                let scrollItemTop = $scrollItem.getBoundingClientRect().top + window.scrollY;
                if (this.$header) {
                    scrollItemTop = scrollItemTop - this.$header.offsetHeight;
                }
                smoothScrollTo(0, scrollItemTop, 500);
            }

            this.setTabBarContentHeight();
        }, 500);
    }

    setTabBarContentHeight () {
        const $tabBarContent = document.querySelector('.product-support-tabs__tab-bar-content');
        const $activeContentItem = $tabBarContent.querySelector('.tab-bar__content-item--active');
        const activeContentItemHeight = $activeContentItem.offsetHeight;
        $tabBarContent.style.height = activeContentItemHeight + 'px';
    }

    setBodyClickEvent () {
        const $productSupportTabs = document.querySelector('.product-support-tabs');
        $productSupportTabs.addEventListener('click', (e) => {
            this.toggleStickyness(e.target);
        });
    }

    toggleStickyness (clickedElement) {
        if (clickedElement) {
            const $clickedElement = clickedElement;
            const $resultsPreviewContainer = document.querySelector('.product-support-form-results-container');
            if (!$clickedElement.classList.contains('selectr-container') && !$clickedElement.classList.contains('selectr-placeholder') && !$clickedElement.classList.contains('selectr-label') && !$clickedElement.classList.contains('selectr-selected') && !$clickedElement.classList.contains('select')) {
                $clickedElement.classList.remove('is--in-front');
                $resultsPreviewContainer.classList.add('is--sticky');
            } else {
                let $selectContainerItem = null;

                if ($clickedElement.classList.contains('selectr-container')) {
                    $selectContainerItem = $clickedElement;
                } else {
                    $selectContainerItem = $clickedElement.closest('.selectr-container');
                }

                if ($selectContainerItem.classList.contains('open')) {
                    $selectContainerItem.classList.add('is--in-front');
                    $resultsPreviewContainer.classList.remove('is--sticky');
                } else {
                    $selectContainerItem.classList.remove('is--in-front');
                    $resultsPreviewContainer.classList.add('is--sticky');
                }
            }
        }
    }
}

export { Filter };
window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$productSupportFilters = $context.querySelectorAll('[data-productsupport-filter="root"]');

        if ($$productSupportFilters.length > 0) {
            for (let i = 0; i < $$productSupportFilters.length; i++) {
                const $productSupportFilter = new Filter($$productSupportFilters[i], {
                    loader: window.OPTIONS.loader,
                    onShowDetails: ($details) => {
                        window.initSupportContent($details);
                        window.scrolling = true;
                    },
                    onSubmitted: ($result) => {
                        window.initSupportContent($result);
                    }
                });
                $productSupportFilter.initialize();
            }
        }
    }
});
